import { useEffect, useState } from 'react'

// Bohužel to nejde udělat jako context, ale musí se používat callbacky, protože
// všechna práce po 'freeze' eventu musí být provedena v jeho callbacku. Další
// rerender se neprovede a po resume eventu se změna nevyvolá, protože hodnota isFrozen
// bude stejná.

export function usePageFreezeStatus(onFreeze: () => void, onResume: () => void) {
  const [isFrozen, setIsFrozen] = useState(false)

  // Callback refs to execute code before freezing and upon resuming
  const freezeHandler = () => {
    console.debug('freeze')
    setIsFrozen(true)
    if (onFreeze) onFreeze()
  }

  const resumeHandler = () => {
    console.debug('resume')
    setIsFrozen(false)
    if (onResume) onResume()
  }

  useEffect(() => {
    document.addEventListener('freeze', freezeHandler)
    document.addEventListener('resume', resumeHandler)

    return () => {
      document.removeEventListener('freeze', freezeHandler)
      document.removeEventListener('resume', resumeHandler)
    }
  }, [onFreeze, onResume])

  return isFrozen
}
